// ClearFilter.jsx
import React from 'react';
import { FILTER_PRESETS } from 'constants/filters';
import FilterPresetButton from './FilterPresetButton';

export default function ClearFilter() {
  return (
    <FilterPresetButton
      presetKey={FILTER_PRESETS.CLEAR}
      label="Clear"
      image="clear"
      thumbnailClassName="bg-gradient-to-br from-slate-200 via-white to-slate-100"
      showRecommended
    />
  );
}
